import React from 'react'
export const useIsOnline = () => {
  const [isOnline, setIsOnline] = React.useState(navigator.onLine)
  window.addEventListener('online', () => {
    setIsOnline(true)
  })
  window.addEventListener('offline', () => {
    setIsOnline(false)
  })

  return [isOnline, setIsOnline]
}
